function prevArrow(name) {
  if (name) {
    return (
      `<button type="button" class="slick-prev">
        <svg class="svg-icon ${name} ">
          <use xlink:href="${baseUrl}img/sprite.svg#${name}"></use>
        </svg>
      </button>`
    );
  } else {
    return '<button type="button" class="slick-prev"></button>';
  }
}

function nextArrow(name) {
  if (name) {
    return (
      `<button type="button" class="slick-next">
        <svg class="svg-icon ${name}">
          <use xlink:href="${baseUrl}img/sprite.svg#${name}"></use>
        </svg>
      </button>`
    );
  } else {
    return '<button type="button" class="slick-next"></button>';
  }
}

function empty_suggestion_template() {
  return `<div class="empty-message">
    <div class="empty-message__title">По вашему запросу ничего не найдено</div>
    <div class="empty-message__subtitle">Спробуйте скоротити запит, написати іншою мовою, перевірити правопис. Або перейдіть на Головну і пошукайте там</div>
  </div>`;
}

function suggestion_template(data) {
  return (
    `<div class="suggestion-item">
      <a class="suggestion-item__link" href="/some-event.html"></a>
      <div class="suggestion-item__image"><img src="http://image.tmdb.org/t/p/w500/${data.image}" alt="${data.title}"/></div>
      <div class="suggestion-item__content">
        <div class="suggestion-item__date">10 - 12 августа</div>
        <div class="suggestion-item__title">${data.title}</div>
        <div class="suggestion-item__place"><svg class="svgicon"><use xlink:href="${baseUrl}img/sprite.svg#loca"></use></svg>${data.place}</div>
        <div class="suggestion-item__price">${data.price}</div>
      </div>
      <div class="suggestion-item__btn"><span>Купить билет</span><svg class="svgicon"><use xlink:href="${baseUrl}img/sprite.svg#arrow-right"></use></svg></div>
    </div>`
    )
}

function html_slide_content(data) {
  if (!data.small || !data.big) {
    return;
  }

  return (
      `<div class="slider_content">
      <div class="slider_content__small">${data.small}</div>
      <div class="slider_content__big">${data.big}</div>
      <div class="slider_content__place">
        <svg class="svgicon"><use xlink:href="${baseUrl}img/sprite.svg#loca"></use></svg>
        <span>${data.place}</span>
      </div>
    </div>`
  )
}

function html_slide_thumb(data) {
  // if (!data.small || !data.big) {
  //   return (
  //     `<div class="slider_preview">
  //       <a href="${data.link}"></a>
  //       <img src="${data.img}" alt="${data.big}" />
  //     </div>`
  //   )
  // }

  // return (
  //     `<div class="slider_preview">
  //     <a href="${data.link}"></a>
  //     <img src="${data.img}" alt="${data.big}" />
  //     <div class="slider_preview__content">
  //       <div class="slider_preview__small">${data.small}</div>
  //       <div class="slider_preview__big">${data.big}</div>
  //       <div class="slider_preview__place">
  //         <svg class="svgicon"><use xlink:href="${baseUrl}img/sprite.svg#loca"></use></svg>
  //         <span>${data.place}</span>
  //       </div>
  //     </div>
  //   </div>`
  // )
}


// aside menu
var Menu = {
  asideMenu: $('.aside-menu'),

  open: function() {
    var _ = this;
    TweenMax.to('.page-overlay', 0.8, {
      autoAlpha: 1
    });
    var tl = new TimelineMax({
      onStart: function() {
        TweenMax.set(_.asideMenu, {
          display: 'block'
        });
      }
    });

    tl
      .from(this.asideMenu, 0.3, {
        autoAlpha: 0,
        x: '-30%',
        ease: Power4.easeOut
      })
      .from('.aside-menu__left .lang-chooser', 0.5, {
        opacity: 0,
        x: -20
      }, '-=0.2')
      .from('.aside-menu__categories', 0.5, {
        opacity: 0,
        x: -20
      }, '-=0.4')
      .from('.aside-menu .b-contacts', 0.5, {
        opacity: 0,
        x: -20
      }, '-=0.4')
      .from('.aside-menu__nav', 0.5, {
        opacity: 0,
        x: -20
      }, '-=0.4');
  },

  close: function() {
    var _ = this;
    TweenMax.to('.page-overlay', 0.5, {
      autoAlpha: 0
    });
    TweenMax.to(this.asideMenu, 0.3, {
      autoAlpha: 0,
      x: '-30%',
      ease: Power4.easeIn,
      onComplete: function() {
        TweenMax.set(_.asideMenu, {
          clearProps: 'all'
        });
      }
    });
  }
}


// carousel with tabs
function init_carousel_tabs(tabs) {
  var $tabs = $(tabs);

  $tabs.each(function() {
    var _ = $(this);
    var buttons = _.find('.tab-button');
    var content = _.find('.category_carousel');
    var first_button = buttons.first();
    var first_content = content.first();
    var slick_args = {
      rows: 0,
      slidesToShow: 4,
      slidesToScroll: 1,
      // autoplay: true,
      prevArrow: prevArrow('keyboard-right'),
      nextArrow: nextArrow('keyboard-right'),
      draggable: false,
      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      }]
    };

    buttons.first().addClass('active');
    content.first().fadeIn(200);
    first_content.slick(slick_args);

    buttons.on('click', function(event) {
      event.preventDefault();
      var target_content = content.filter($(this).attr('href'));
      buttons.removeClass('active');
      $(this).addClass('active');

      content.hide();
      target_content.show();
      if (!target_content.hasClass('slick-initialized')) {
        target_content.slick(slick_args);
      }
    });

  });
}



// promo slider
function promo_slider() {
  var $promo_slider = $('.promo-slider');
  $promo_slider.slick({
    rows: 0,
    // autoplay: true,
    arrows: false,
    // prevArrow: prevArrow('keyboard-right'),
    // nextArrow: nextArrow('keyboard-right'),
    draggable: false
  });

  $(document).on('click', '.promo-slide .slick-arrow', function(event) {
    event.preventDefault();
    if ($(this).hasClass('slick-prev')) {
      $promo_slider.slick('slickPrev');
    } else {
      $promo_slider.slick('slickNext');
    }
  });
}

// detect scrollbar width
function scrollbar_measure() {
  // Create the measurement node
  var scrollDiv = document.createElement("div");
  scrollDiv.className = "scrollbar-measure";
  document.body.appendChild(scrollDiv);

  // Get the scrollbar width
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  // Delete the DIV
  document.body.removeChild(scrollDiv);

  return scrollbarWidth;
}

// callbacks for magnificPopup to control fixed header
var mp_callbacks = {
  open: function() {
    if (scrollbar_measure() != 0) {
      $('.header').css('right', 15);
    }
  },
  close: function() {
    if (scrollbar_measure() != 0) {
      $('.header').removeAttr('style');
    }
  }
}

const scrollToElem = (selector) => {
  const y = document.querySelector(selector).getBoundingClientRect().y
  console.log(y)
  window.scrollTo({
    top: y,
    behavior: "smooth"
  })
}